// extracted by mini-css-extract-plugin
export default {"titleQ":"Title_titleQ__ZstWK","svgQ":"Title_svgQ__bOrbg","tilt-animation":"Title_tilt-animation__J-kfC"};